import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const UpdateProfileContext = createContext(null);

type Props = {
  children: ReactElement;
};

const UpdateProfileProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.put("account/", payload);
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <UpdateProfileContext.Provider value={contextValue}>
      {children}
    </UpdateProfileContext.Provider>
  );
};

export default UpdateProfileProvider;
